import { connect } from 'react-redux'
import { formValueSelector, reduxForm } from 'redux-form/immutable'
import { Map } from 'immutable'

import {
  doneReviewsSurveyByIdForReviewer,
  doneReviewsSurveyByIdForUser,
  triggerReviewsSurveyProcess,
} from 'store/entities/reviewsSurveys/actions'
import { getAskingSurvey } from 'store/entities/reviewsSurveys/selectors'
import { queryParams } from 'store/entities/router/selectors'

import { ICompetencyQuestions, IQuestions } from 'store/entities/reviewsSurveys/interfaces/reducer.interfaces'
// @ts-ignore
import { getUIWindowSizesHeight } from 'store/entities/ui/selectors'
import ReviewsSurveyQuestions from './ReviewsSurveyQuestions'
import {
  EEndText,
  EInstructions,
  EReviewsTypes,
  ETypeOfIdentityForSurvey,
  EWelcomeText,
  ISurveyKeys,
  REVIEWS_TIME_TO_REVIEWS_TYPES,
  REVIEWS_USER_TYPES,
  TReviewsTimes,
} from 'app/constants/reviews'
import { IReviewsSurveyQuestionsParams } from './interface'
import { REVIEWS_SURVEY_COMPLETED_PATH } from 'app/constants/navLinks'
import { substituteParticipantFirstNameAndLastName } from 'helpers/reviews'
// @ts-ignore
import { email } from 'helpers/validators'

const FORM_NAME = 'REVIEWS_SURVEY_QUESTIONS_FORM'
const selector = formValueSelector(FORM_NAME)

interface IAdditional {
  answer: string
  question: string
}

interface ICompetencyWithAnswers {
  answer: number
  question: string
}

interface ICompetency {
  answers: number[]
  competency: string
  questionsWithAnswers: ICompetencyWithAnswers[]
}

const formProps = {
  form: FORM_NAME,
  onSubmit: (
    values: any,
    dispatch: any,
    {
      survey,
      params,
      reviewsType,
      isSurveyForUser,
      location,
    }: {
      survey: any
      params: IReviewsSurveyQuestionsParams
      reviewsType: EReviewsTypes
      isSurveyForUser: boolean
      location: Location
    }
  ) => {
    console.log('__onSubmit__', { values: values.toJS(), params, locationsdsd: location })
    const surveyData = survey.toJS()
    let identityRequest = ETypeOfIdentityForSurvey.reviewerQuestion
    if (isSurveyForUser) {
      identityRequest = ETypeOfIdentityForSurvey.userQuestion
    }

    console.log('__surveyData__', surveyData)
    const competenciesQuestions = values.get('competenciesQuestions')
      ? values.get('competenciesQuestions').toList()
      : undefined
    const employees = values.get('employees')
    const superiors = values.get('superiors')
    const peers = values.get('peers')
    const t1 = values.get('t1')
    const t2 = values.get('t2')
    const data = values
      .set('id', survey.get('id'))
      .set(
        'competenciesQuestions',
        competenciesQuestions.map((competencyQuestions: any) => {
          return competencyQuestions.toList()
        })
      )
      .set('employees', employees && employees.toList())
      .set('superiors', superiors && superiors.toList())
      .set('peers', peers && peers.toList())
      .set('t1', t1 && t1.toList())
      .set('t2', t2 && t2.toList())
    console.log('__data__', { dataToJS: data.toJS(), data })
    const requestData = {
      id: survey.get('id'),
      firstName: data.get('firstName'),
      lastName: data.get('lastName'),
      email: data.get('email'),
      surveyAnswers: {
        additionals: [] as IAdditional[],
        competencies: [] as ICompetency[],
        competencyBlocksNames: [] as string[],
      },

      superiors: data
        .get('superiors')
        ?.filter(
          (reviewer: Map<string, string>) =>
            !!(reviewer.get('email') && reviewer.get('firstName') && reviewer.get('lastName')) &&
            !email(reviewer.get('email'))
        )
        .toJS(),
      peers: data
        .get('peers')
        ?.filter(
          (reviewer: Map<string, string>) =>
            !!(reviewer.get('email') && reviewer.get('firstName') && reviewer.get('lastName')) &&
            !email(reviewer.get('email'))
        )
        .toJS(),
      employees: data
        .get('employees')
        ?.filter(
          (reviewer: Map<string, string>) =>
            !!(reviewer.get('email') && reviewer.get('firstName') && reviewer.get('lastName')) &&
            !email(reviewer.get('email'))
        )
        .toJS(),
      organizationId: parseInt(params.organization_id, 10),
      participantEmail: params.participantemail,
      reviewsType,
      reviewerEmail: params.revieweremail,
      linkForRedirect: `${REVIEWS_SURVEY_COMPLETED_PATH}${location.search}`,
    }

    surveyData.competenciesQuestions.forEach((competencyQuestions: ICompetencyQuestions, i: number) => {
      const competencyName = competencyQuestions.name
      const competencyAnswers = data.getIn(['competenciesQuestions', i])
      requestData.surveyAnswers.competencyBlocksNames.push(competencyName)
      const el = {
        competency: '',
        answers: [],
        questionsWithAnswers: [],
      } as ICompetency
      el.competency = competencyName
      competencyQuestions.questions.forEach((question, indexQuestion) => {
        const answerIndex = parseInt(competencyAnswers.get(indexQuestion))
        el.answers.push(answerIndex)
        el.questionsWithAnswers.push({
          question: question[identityRequest],
          answer: answerIndex,
        })
      })
      requestData.surveyAnswers.competencies.push(el)
    })
    if (surveyData.openEndedQuestions) {
      surveyData.openEndedQuestions[reviewsType].forEach((openEndedQuestion: IQuestions, i: number) => {
        requestData.surveyAnswers.additionals.push({
          question: openEndedQuestion[identityRequest],
          answer: data.getIn([reviewsType, i]),
        })
      })
    }
    if (requestData.reviewerEmail) {
      dispatch(doneReviewsSurveyByIdForReviewer(requestData))
    } else {
      dispatch(doneReviewsSurveyByIdForUser(requestData))
    }
  },
  initialValues: Map({
    firstName: '',
    lastName: '',
    email: '',
  }),
}

const mapStateToProps = (state: any) => {
  const { firstName, lastName, email } = selector(state, 'firstName', 'lastName', 'email')
  const getFormValue = (field: string) => selector(state, field)
  const params = queryParams(state) as IReviewsSurveyQuestionsParams
  const time = params.time as TReviewsTimes
  const isSurveyForUser = !params.revieweremail
  const survey = getAskingSurvey(state)
  const participantFirstName = firstName || params.participantfirstname
  const participantLastName = lastName || params.participantlastname
  const participantEmail = email || params.participantemail
  const reviewerFirstName = params.reviewerfirstname
  const reviewerLastName = params.reviewerlastname
  const reviewerEmail = params.revieweremail
  let surveyKeys = {
    welcomeText: EWelcomeText.reviewerWelcomeText,
    instructions: EInstructions.reviewerInstructions,
    questionType: ETypeOfIdentityForSurvey.reviewerQuestion,
    endText: EEndText.reviewerEndText,
  } as ISurveyKeys
  if (isSurveyForUser) {
    surveyKeys = {
      welcomeText: EWelcomeText.participantWelcomeText,
      instructions: EInstructions.participantInstructions,
      questionType: ETypeOfIdentityForSurvey.userQuestion,
      endText: EEndText.participantEndText,
    }
  }
  let titleInstructions = substituteParticipantFirstNameAndLastName(
    survey.get(surveyKeys.instructions),
    REVIEWS_USER_TYPES.USER,
    participantEmail,
    participantFirstName,
    participantLastName
  ) as string
  let titleWelcomeText = substituteParticipantFirstNameAndLastName(
    survey.get(surveyKeys.welcomeText),
    REVIEWS_USER_TYPES.USER,
    participantEmail,
    participantFirstName,
    participantLastName
  ) as string
  let titleEndText = substituteParticipantFirstNameAndLastName(
    survey.get(surveyKeys.endText),
    REVIEWS_USER_TYPES.USER,
    participantEmail,
    participantFirstName,
    participantLastName
  ) as string
  if (!isSurveyForUser && reviewerEmail) {
    titleInstructions = substituteParticipantFirstNameAndLastName(
      titleInstructions,
      REVIEWS_USER_TYPES.REVIEWER,
      reviewerEmail,
      reviewerFirstName,
      reviewerLastName
    )
    titleWelcomeText = substituteParticipantFirstNameAndLastName(
      titleWelcomeText,
      REVIEWS_USER_TYPES.REVIEWER,
      reviewerEmail,
      reviewerFirstName,
      reviewerLastName
    )
    titleEndText = substituteParticipantFirstNameAndLastName(
      titleEndText,
      REVIEWS_USER_TYPES.REVIEWER,
      reviewerEmail,
      reviewerFirstName,
      reviewerLastName
    )
  }
  return {
    survey,
    reviewsType: REVIEWS_TIME_TO_REVIEWS_TYPES[time],
    params,
    getFormValue,
    height: getUIWindowSizesHeight(state),
    isSurveyForUser,
    surveyKeys,
    titleWelcomeText,
    titleInstructions,
    titleEndText,
    participantFirstName,
    participantLastName,
    participantEmail,
  }
}

const mapDispatchToProps = {
  triggerReviewsSurveyProcess,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(reduxForm(formProps)(ReviewsSurveyQuestions))
